@if (selection) {
  <div class="selected-location-icon">
    <app-location-icon
      [kind]="getKind(selection)"
      [locationGroup]="isLocationGroup(selection)"
    ></app-location-icon>
  </div>
}
<!-- The model is the search text, which is cleared once a location or group is
     picked, so the current selection is carried by the placeholder instead. -->
<p-autocomplete
  [(ngModel)]="searchQuery"
  [suggestions]="suggestions"
  (completeMethod)="search($event)"
  (onSelect)="onSelectionChange($event)"
  [placeholder]="getPlaceholder()"
  minQueryLength="3"
  [appendTo]="appendTo()"
  [showEmptyMessage]="true"
  [required]="required() && !selection"
  [class]="!!selection ? 'with-icon' : 'no-icon'"
>
  <ng-template let-option #item>
    <div
      aria-hidden="true"
      class="item-wrapper"
      [class.not-active]="!isSelectable(option)"
      (click)="!isSelectable(option) ? $event.stopPropagation() : null"
    >
      <app-location-icon
        [kind]="getKind(option)"
        [locationGroup]="isLocationGroup(option)"
      ></app-location-icon>
      {{ getName(option) }}
      @if (getKind(option) === locationKind.airport) {
        <span>, {{ getCode(option) }}</span>
      }
    </div>
  </ng-template>
  <ng-template #empty>
    <app-autocomplete-empty-message
      [loading]="loading()"
      text="Location or group not found"
    ></app-autocomplete-empty-message>
  </ng-template>
</p-autocomplete>
<div class="filter-info">
  @for (kind of locationKindFilterOptions; track kind) {
    <app-location-icon
      aria-hidden="true"
      (click)="setLocationKindFilter(kind)"
      [class.active]="locationKindFilter === kind"
      [kind]="kind"
    ></app-location-icon>
  }
</div>
